import { ref } from 'vue';
import DocumentsAPI from '@/api/documents';

const VALID_EXTENSIONS = ['.pdf', '.docx', '.xlsx', '.xls'];

export function useDocuments() {
  const documents = ref([]);
  const selectedFile = ref(null);

  const fetchDocuments = async () => {
    documents.value = await DocumentsAPI.getDocuments();
  };

  const selectFile = (file) => {
    if (!file) return false;

    const ext = '.' + file.name.split('.').pop().toLowerCase();
    if (!VALID_EXTENSIONS.includes(ext)) return false;

    selectedFile.value = file;
    return true;
  };

  const uploadDocument = async () => {
    if (!selectedFile.value) return false;

    try {
      const formData = new FormData();
      formData.append('file', selectedFile.value);

      await DocumentsAPI.uploadDocument(formData);
      selectedFile.value = null;
      await fetchDocuments();
      return true;
    } catch (e) {
      return false;
    }
  };

  const deleteDocument = async (doc) => {
    try {
      await DocumentsAPI.deleteDocument(doc.id);
      await fetchDocuments();
      return true;
    } catch (e) {
      return false;
    }
  };

  return {
    documents,
    fetchDocuments,
    selectFile,
    uploadDocument,
    deleteDocument,
  };
}
